document.addEventListener('alpine:init', function () {
    Alpine.data('heroBanner', function (slidesCount) {
        var glide;
        return {
            activeSlide: 0,
            init: function () {
                if (slidesCount > 1) {
                    this.initialiseCarousel();
                }
            },
            initialiseCarousel: function () {
                var _this = this;
                glide = new window.Glide(this.$refs.carousel, {
                    type: 'carousel',
                    gap: 32,
                    perView: 1,
                }).mount();
                glide.on('move.after', function () {
                    _this.activeSlide = glide.index;
                    // Set slides that are not active to be 'inert'.
                    var slides = Array.from(_this.$refs.carousel.querySelectorAll('.glide__slide'));
                    slides.forEach(function (slide) {
                        var isActive = slide.classList.contains('glide__slide--active');
                        var videoEl;
                        if (slide.getAttribute('data-slide-type') === 'video') {
                            videoEl = slide.querySelector('video');
                        }
                        if (isActive) {
                            slide.removeAttribute('inert');
                            videoEl && videoEl.play();
                        }
                        else {
                            slide.setAttribute('inert', '');
                            videoEl && videoEl.pause();
                        }
                    });
                });
            },
            goToSlide: function (index) {
                glide.go("=".concat(index));
            },
        };
    });
});
